module.exports = __webpack_public_path__ + "static/img-2-1800b4c90da80410bbdd5bd0da4bb497.jpg";